import logger from 'loglevel';

// The dev environment build (--mode dev) keeps debug logs; other production builds only log errors.
const isVerbose = !import.meta.env.PROD || import.meta.env.MODE === 'dev';
logger.setLevel(isVerbose ? 'debug' : 'error');
// logger.info('Logger is set to: ', Object.keys(logger.levels)[logger.getLevel()]);
// Set logger to window object - is not recommended
// window.logger = logger;

export default logger;
